import React, { SFC } from 'react';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import App from '../components/app';
import rootReducer from '../reducers';
import { initOptimizeSuite } from '../helpers/optimize';

initOptimizeSuite();

const store = createStore(rootReducer, compose(applyMiddleware(thunk)));

const AppContainer: SFC<{}> = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

export default AppContainer;
